import * as React from "react";

import { InputField, RadioGroupField } from "affinityForm/fields";
import { Grid } from "affinityUI/elements/grid";
import { DataEntryGroup } from "affinityUI/form/components";
import { PreferredContactMethod } from "types";

const DEFAULT_COLS = { xs: [1], lg: [1, 1] };

export const SectionContact: React.FC = () => (
  <DataEntryGroup title="Contact details" id="contact">
    <Grid $cols={DEFAULT_COLS}>
      <InputField name="contactDetails.primaryContact">Primary contact number</InputField>
    </Grid>
    <Grid $cols={DEFAULT_COLS}>
      <InputField name="contactDetails.secondaryContact">
        Secondary contact number <span>(optional)</span>
      </InputField>
    </Grid>
    <RadioGroupField
      name="contactDetails.preferredContactMethod"
      options={
        [
          { id: "Phone", label: "Phone" },
          { id: "Email", label: "Email" },
        ] satisfies { id: `${PreferredContactMethod}`; label: string }[]
      }
    >
      Contact preference
    </RadioGroupField>
    <Grid $cols={DEFAULT_COLS}>
      <InputField name="contactDetails.email">Email</InputField>
    </Grid>
    <Grid $cols={DEFAULT_COLS}>
      <InputField name="oncologist">
        Patient&apos;s oncologist <span>(optional)</span>
      </InputField>
    </Grid>
  </DataEntryGroup>
);
